// Thirdparty
// useState lets us add react state to function components
// useEffect lets us performs side effects in function components.
import {useState, useEffect} from 'react' // The state hook used rather than classes
import {Link} from 'react-router-dom';
// Styles
import './../styles/Home.css';
// Assets
import heroImage from './../assets/hero-1.png';
// Services
const Routes = require("./../services/routes.js");

//! \todo remove before production
async function fetchIndex(){
  try{
    const url = Routes.getHostURL() + "/";
    const origin = window.location.origin;
    console.log(`Sending message to ${url} with origin ${origin}`);
    
    const response = await fetch(
      url,
      {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        credentials: "include",
      }
    );
    console.log(`Fetch message returned ${response.status}: ${response.statusText}`);
    const result = await response.json();
    console.log(`Fetch message result ${JSON.stringify(result)}`);
  }
  catch(err){
    console.error("Failed fetch message:", err);
  }
}

function Home(){
  // pass in the initial state. returns the current state and a function to update it.
  //const [data, setData] = useState([]);

  // This is triggered after the render call. (First render and update renders)
  // function callback is passed in
  useEffect (() => {
  }, []);

  return(
    <div>

      <div className="dark-container">
        
        {/* <!-- Hero Container --> */}
        <div className="home-hero-container">
          <img src={heroImage} alt="hero graphic" className="home-hero"/>
          <div className="home-hero-text">
            <h1>Crypta</h1>
            <p>Earn yield on liquidity holdings. Trade to increase portfolio. Entertainment through verifiable blockchain games.</p>
            <Link to="/Lottery" className="home-cta">Open App</Link>
            {/* //! \todo remove before production */}
            <button type="button" onClick={fetchIndex}>Test Fetch</button>
          </div>
        </div>

      </div>

  </div>
  )
}

export default Home;